var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChooseMobywatelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32 {\n        stroke-width: 0px;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #c3bdc9;\n      }\n\n      .cls-3 {\n        fill: #dfa12f;\n      }\n\n      .cls-4 {\n        fill: #c4c0cd;\n      }\n\n      .cls-5 {\n        fill: #c3bec9;\n      }\n\n      .cls-6 {\n        fill: #e0dee2;\n      }\n\n      .cls-7 {\n        fill: url(#Gradient_bez_nazwy_3-2);\n      }\n\n      .cls-8 {\n        fill: #c5bdcb;\n      }\n\n      .cls-9 {\n        fill: #e1a02f;\n      }\n\n      .cls-10 {\n        fill: #f6d155;\n      }\n\n      .cls-11 {\n        fill: #dfdde1;\n      }\n\n      .cls-12 {\n        fill: #e1dfe3;\n      }\n\n      .cls-13 {\n        fill: #c3beca;\n      }\n\n      .cls-14 {\n        fill: #e0dee4;\n      }\n\n      .cls-15 {\n        fill: #dea12f;\n      }\n\n      .cls-16 {\n        fill: #dfdce1;\n      }\n\n      .cls-17 {\n        fill: #f1eef0;\n      }\n\n      .cls-18 {\n        fill: #e8e6eb;\n      }\n\n      .cls-19 {\n        fill: #dc143c;\n      }\n\n      .cls-20 {\n        fill: #dfdde2;\n      }\n\n      .cls-21 {\n        fill: url(#Gradient_bez_nazwy_3-3);\n      }\n\n      .cls-22 {\n        fill: #cecad5;\n      }\n\n      .cls-23 {\n        fill: #c4beca;\n      }\n\n      .cls-24 {\n        fill: #b6b1bf;\n      }\n\n      .cls-25 {\n        fill: #aaa3b5;\n      }\n\n      .cls-26 {\n        fill: #e0dee3;\n      }\n\n      .cls-27 {\n        fill: #c1c0c8;\n      }\n\n      .cls-28 {\n        fill: #c4becb;\n      }\n\n      .cls-29 {\n        fill: url(#Gradient_bez_nazwy_3);\n      }\n\n      .cls-30 {\n        fill: #c3bdca;\n      }\n\n      .cls-31 {\n        fill: #dfdde3;\n      }\n\n      .cls-32 {\n        fill: #c4bec9;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3",
    "data-name": "Gradient bez nazwy 3",
    x1: 23.25,
    y1: 3.41,
    x2: 25.78,
    y2: 1.41,
    gradientTransform: "translate(-13.79 14.19) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3bdc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3bdc9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3-2",
    "data-name": "Gradient bez nazwy 3",
    x1: 30.83,
    y1: -1.13,
    x2: 23.17,
    y2: 2.83,
    xlinkHref: "#Gradient_bez_nazwy_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradient_bez_nazwy_3-3",
    "data-name": "Gradient bez nazwy 3",
    x1: 34.93,
    y1: 4.21,
    x2: 30.34,
    y2: 0.7,
    xlinkHref: "#Gradient_bez_nazwy_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 0,
    width: 29,
    height: 29,
    rx: 7,
    ry: 7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path3360",
    className: "cls-10",
    d: "M12.7,2.75c.38.67.54,1.31.75,1.91.35-.05.76.05,1.15.08.46.09.82.13,1.15.08.21-.96.39-1.43.8-2.11-.18.12-.57.18-.73.4-.23-.2-.41-.08-.53.14.04-.17-.01-.32-.24-.33.13-.25-.07-.38-.29-.26,0-.22-.18-.22-.19-.34-.03.13-.18.07-.16.39-.17-.14-.34-.05-.28.2-.21,0-.27.17-.25.39-.15-.34-.42-.23-.51-.12-.17-.34-.3-.12-.69-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3358",
    className: "cls-1",
    d: "M16.09,4.46c-.25.42-.35.45-1.43.29-.85-.08-1.62-.32-1.65.45.28.03.69.06.87.67l-.52.44c-.37.06-.95.55-1.33.09-.11.43.29.55.7.53.29-.03.38-.11.92-.21l.14.15c.81.07,1.24,1.23-.08,1.91-.05.16.03.35.16.37-.38.54-1.01,1.22-1.24.77-.05.05-.2.42.09.62-.22.27-.3.59-.29.95-.87-.14-1.44-.28-1.25-1.1.93.04,1.18-1.07,1.04-1.64-.54-2.26-3.46-4.08-5.58-4.14.12.62.5,1.06.93,1.47-.56-.27-1.22-.54-1.9-.4.08.49.34,1.05,1.45,1.97-.8-.48-1.54-.94-1.8-1.32-.12.16-.18.79.5,1.25-.22-.09-1.29-.08-1.61.16.2.45,1.09,1.22,1.82,1.46-.7-.1-1.35-.38-1.95-.89-.09.08,0,.9.75,1.23-.24.02-1.06.25-1.27.51.43.57,1.52,1.07,2.06,1.08-.74.1-1.55-.05-1.89-.16,0,.19-.15.95,1.88.82-.72.34-1.82,1.05-1.99,1.68.7.31,1.96.05,2.62-.15-1.93,1.18-2.23,1.3-2.59,1.22.47.99,1.59.32,2.56-.23-1.2,1.6-1.39,2.41-1.36,3.55.96-.12,2.36-1.49,3.1-2.67-.86,1.77-1.37,3.19-2.31,3.61,1.07.42,1.99-.92,2.63-2.34-.25.9-.35,2.81-.03,3.28.97-.65,1.7-2.11,2.19-3.78-.17.82-.29,1.64-.59,2.46.62.12.94-1,1.15-1.65.02.03.04.06.1.12.78-.57,1.03-1.89,1.09-2.41.72.2,1.03-.06,1.21-.19.16.22.17.56.21.6-.78-.63-1.61,0-1.65,1.05-.08.44-.32.95-.91,1.34.04.05.12.07.23.07-.1.18-.2.33-.37.49.04.03.1.03.15.04-.13.22-.35.42-.57.53.05.05.08.07.24.11-.15.19-.38.37-.61.46.43.25.75.29,1.02.26,0,0,0,0,0,0-.17.33-.44.5-.71.65.08.08.18.09.26.07-.24.25-.49.45-.72.52.04.03.07.07.22.06-.16.2-.36.4-.71.49.07.13.21.11.34.12-.1.21-.4.28-.7.34.23.06.39.19.25.16-.09.11-.18.17-.38.2-.2.03-.93-.23-1.23-.13-.08-.17-.29-.28-.5-.28-.27,0-.54.17-.55.42-.04-.03-.22-.05-.19.16.06.12.07.22.46.37.06.03.14.04.24.04.14,0,.3-.08.41-.18h0c.19.04.41.07.53.12-.31.02-.41.19-.59.32-.07,0-.14-.02-.2-.03h0s-.08-.01-.12-.01c-.22.01-.44.26-.47.54,0,.06,0,.11.04.16v.05c-.07.08-.04.14.02.19.27.11.43.04.53.02.24-.03.45-.23.45-.45,0,0,0,0,0,0h0c.29-.05.57-.13.73-.25,0,.02.01.04,0,.06-.1.06-.27.15-.35.44-.03,0-.05,0-.07,0-.33,0-.41.23-.41.41,0,.18.07.3.17.37-.02.11,0,.21.11.25.39.06.49-.14.57-.14,0-.05,0-.09.02-.12.12-.06.2-.1.21-.33.01-.14-.01-.23-.06-.28h.01s0,0,0,0c0,0,0,0,0,0h0s0,0,0,0c.36-.31.59-.55.75-.76.14.03.45.02.6-.03v.06c-.15.14-.05.47.14.46,0,.03,0,.06,0,.09.12.08.35.02.53.06.09-.01.13-.07.11-.19h0c.14-.08.23-.23.22-.42,0-.26-.2-.47-.46-.49h0c-.27-.03-.53.16-.47-.26.74-.87,1.74-2.19,2.02-2.35-.02-.03-.04-.07-.05-.1.11.29.52.59.96.57-.08-.15-.17-.28-.2-.68.06.09.18.14.31.17-.2-.93.1-1.69.72-2.39-.05.9-.16,1.8-.71,2.72.28.09.65-.2.7-.37.06.81-.71,1.85-1.31,1.35-.38.83.52,1.23,1.08.75-.1.5-.49.8-.91.91-.43.12-.87-.07-.59-.75-.06-.04-.92-.06-.94.88.03.54.39.74.42.75-1.22.93,0,1.96,1.02,1.76.8-.12,1.25-.77,1.54-1.24-.09.34-.45,1.42.47,2.6.91-1.42.53-2.38.5-2.54.72,1.11,1.42,1.18,1.84,1.16.71.01,1.73-1.11.44-1.83.66-.31.7-1.61-.23-1.68.19.52-.21.83-.66.79-.44-.04-.85-.3-1.01-.87.87.42,1.28-.41.98-.86-.75.62-1.1-.37-1.2-.96.19.15.36.2.68.15-.61-.78-.75-1.83-.8-2.81.41.66.82,1.46.81,2.25.1-.05.18-.06.35-.4.02.59-.05.67-.25.92.33.14.76-.13.96-.48,0,0,0,0,0,0,.63.86,1.32,1.74,1.99,2.42.14.15.19.3-.07.35-.86-.32-.95.58-.59.7-.03.08-.04.16-.01.25.17.05.51-.09.61-.09.04-.04.04-.12.04-.2.09,0,.14-.05.19-.12.17.03.33.05.54-.12l.63.64s-.03.09.06.1c-.07.42.09.47.23.58-.03.4.58.17.64.19.06-.04.07-.08.06-.13.07-.07.04-.11.01-.16.3-.46-.13-.81-.36-.77-.25-.28-.43-.39-.64-.56.42.16,1.06.33,1.24.47.07.47.48.28.79.29.09-.13.04-.17,0-.22.4-.52-.44-.94-.8-.64-.21-.2-.4-.23-.59-.31.08-.08.25-.14.63-.17.17.11.34.15.51.03.07.16.22.12.27.09.13-.14.13-.36.16-.57-.03-.07-.09-.12-.18-.12-.26-.44-.76-.17-.79.03-.43.04-.82.09-1.27.27-.15.05-.29-.12-.42-.21.12-.05.22-.1.21-.2-.19-.02-.37,0-.58-.23l.06-.15c-.17-.05-.34-.17-.56-.51.05-.03.09-.07.13-.15-.25-.06-.45-.19-.61-.38.06-.03.11-.08.17-.16-.23-.14-.45-.26-.89-.84,0,0,0,0,0,0,.46.08.95.03,1.24-.18-.23-.06-.63-.2-.81-.54.09,0,.14-.02.19-.04-.35-.23-.44-.35-.53-.54.07,0,.18-.03.21-.08-.22-.1-.32-.24-.4-.39.09,0,.19.02.26-.04-.89-.4-.76-2.48-1.72-2.48-.42.03-.5.13-.72.24.06-.18.17-.34.29-.51.52.24.93.11,1.07-.02.07.83.34,1.73.92,2.18.1-.06.22-.13.29-.21.1.78.39,1.79,1.04,1.71-.3-.75-.29-1.5-.33-2.24.27,2.19.94,3.47,1.5,3.85.26-.34.45-1.94.32-2.9.55.99,1.15,1.9,1.66,1.9.23,0,.49-.19.64-.24-.8-.32-1.34-1.79-1.83-2.7.92,1.44,2.01,2.08,2.52,2.18.02-.44.12-1.69-1.03-3.41,2.04,1.08,2.48.38,2.6.01-.92.32-2.16-.86-3-1.24v-.03c1.21.56,2.4.75,3.15.28-.64-.98-1.25-1.34-1.92-1.59,1.32.15,1.76-.3,1.78-.8-.48.16-.93.19-1.5.1,1.27-.25,1.49-.79,1.48-.85-.32-.25-.94-.54-1.49-.59,1.53-.55,1.04-1.06.98-1.23-.47.44-1.3.76-1.45.75.71-.37,1.33-1.34,1.29-1.45-.36-.18-1.09-.17-1.39-.08.3-.33.69-.88.33-1.34-.35.49-.67.75-1,1,.3-.38.64-.81.76-1.69-.45.06-.85.01-1.43.4.33-.41.54-.82.58-1.32-1.99.14-4.32,1.18-5.45,3.79-.33.77-.07,2.07.95,1.92.16.66-.27,1.06-1.22,1.03-.02-.22.05-.66-.22-.89.23-.01.27-.13.32-.23-.62-.14-.52-.35-.4-1.44.08.03.17.01.24-.05-.25-.23-.17-.67-.04-2.04.03-.6-.1-.9-.23-1,.08-.04.13-.1.09-.25.29-.05.16-.4.05-.51-.06.16-.3.21-.53.04.28-.13.28-.45.07-.67h0ZM17.25,19.18s.02.02.03.03c0,0-.02-.02-.03-.03,0,0,0,0,0,0h0ZM11.41,19.22c-.03.1.02.39.03.57.09.05.26,0,.45-.07-.01,0-.02,0-.03.01-.14.05-.32.11-.42.06l-.03-.42s0-.1,0-.16c0,0,0,0,0,0h0ZM11.34,19.24s-.03,0-.05.01c.02,0,.03,0,.05-.01ZM17.37,19.29c.21.15.47.16.57.14,0-.01.01-.02.01-.04,0,.01,0,.03-.01.04-.2.03-.39,0-.57-.14h0ZM10.11,22.81s0,0,0,0h0s0,0,0,0h0ZM15.51,23.04c.2.21.96.77,1.85.5.07.5-.35.69-.69.62-.33-.07-.82-.33-1.16-1.12h0ZM13.75,23.17c-.29.55-.76,1.01-1.19,1.12-.42.11-.82-.1-.67-.65.92.31,1.66-.24,1.85-.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3362",
    className: "cls-20",
    d: "M9.52,13.03c-.31-.37-.26-.6-.25-.73-.34-.26-.25-.36-.31-.46.12.21.24.35.36.37.23.21.45.28.68.41-1.38-.75-1-1.68-.98-1.94-.22,0-.37-.04-.49-.12.04-.37.24-.68.65-.88-.05.02-.1.04-.16.05-.05-.01-.17-.32-.02-.52.09-.05.32-.07.55.02.14-.28.32-.53.7-.63.09.1.25.38.14.88.15.06.31.13.43.31-.04.16-.08.2-.12.24.6,0,.66-.84-.01-.93.11-.8-.91-1.27-1.36-.29-.82-.22-1.04.42-.73.92-.1.07-.91.67-.14,1.53,0,.42.11.83.68,1.19.16.48.27.48.39.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3364",
    className: "cls-20",
    d: "M19.67,8.58l.11-.21c.74-.11,1.18.38.89.96.59.51.27,1.17-.09,1.3.43-.32.19-.41.12-.41.02-.01.06-.03.09-.06-.02-.28-.13-.54-.56-.86.21-.23.19-.46.16-.61-.24-.06-.44-.04-.63.05l-.09-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3366",
    className: "cls-20",
    d: "M18.65,10.01c.03-.12.07-.3.27-.47-.07.05-.14.11-.22.18-.27-.11-.44-.35-.48-.5.16-.21.55-.18.61-.17-.11-.43.03-.74.14-.87.35.03.54.21.68.38l.11-.19c-.1-.3-.39-.53-.74-.45-.29.03-.62.28-.49.88-.88.35-.5,1.19.12,1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3368",
    className: "cls-17",
    d: "M16.74,11.51c-.03.32-.1.56-.16.78,1.19-.18,2.96-.49,2.72-1.8-.22.16-.43.19-.65.19-.04-.19-.06-.38,0-.64-.2.27-.43.37-.67.43,1.08.48-.46,1.33-1.1,1.04h-.14,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3370",
    className: "cls-18",
    d: "M12.44,12c.03.37.15.82.26,1.24-.08-.12-.3-.85-.26-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3372",
    className: "cls-2",
    d: "M15.98,11.74c-.29,1.14.98,1.03.09-.14.87.53.3,1.32.25,1.5-.14-.61-.67-.77-.35-1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3374",
    className: "cls-1",
    d: "M10.24,8.61l-.43,1.26c-.11-.05-.21-.09-.34-.25,0-.44.39-.98.77-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3376",
    className: "cls-2",
    d: "M10.59,11.07l-.77-1.2c.12,0,.26,0,.43-.04.23.21.48.77.34,1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3378",
    className: "cls-1",
    d: "M10.37,9.48c.23.06.4.22.42.31l-.55.05c.05-.11.09-.24.12-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3380",
    className: "cls-1",
    d: "M9.01,9.72c-.1-.15-.1-.45,0-.51l.46.42c-.12.03-.34.04-.46.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3382",
    className: "cls-1",
    d: "M8.53,10.54l1.28-.66s-.18-.21-.34-.25c-.34-.04-.91.38-.94.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3384",
    className: "cls-29",
    d: "M9.59,10.54c-.66,1.89,2.18,2.18,2.94,2.24l-.09-.47c-1.37-.06-2.65-.36-2.46-1.4-.25-.16-.3-.23-.38-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3386",
    className: "cls-7",
    d: "M9.59,10.54c-.15.07-.37.11-.58.14-.55,2.29,3,2.47,3.68,2.55-.11-.21-.13-.32-.16-.46-1.8-.12-3.47-.79-2.94-2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3388",
    className: "cls-2",
    d: "M18.98,8.19c.2.41.41.89.56,1.35.09-.13.17-.25.34-.4-.09-.43-.31-.89-.9-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3390",
    className: "cls-1",
    d: "M18.98,8.19c.2.42.43.92.56,1.35l-.48-.07c-.29-.31-.36-.93-.08-1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3392",
    className: "cls-2",
    d: "M18.23,9.21c.13-.14.39-.19.61-.15.05.12.13.29.22.42l-.82-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3395",
    className: "cls-2",
    d: "M20.37,8.71l-.49.44.32.17c.26-.22.19-.61.17-.61h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3397",
    className: "cls-2",
    d: "M19.88,9.14c-.08.02-.35.4-.34.39l1.23.63c0-.21-.19-.74-.9-1.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3399",
    className: "cls-2",
    d: "M19.54,9.53l-.89,1.15c.57-.02.8-.28.99-.59l-.11-.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3401",
    className: "cls-1",
    d: "M20.37,8.71c-.19-.06-.44-.04-.62.05.06.12.1.28.13.38l.49-.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3403",
    className: "cls-1",
    d: "M19.54,9.53l1.24.63c-.23.19-.94.01-1.13-.07l-.1-.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3405",
    className: "cls-1",
    d: "M19.54,9.54l-.49-.07c-.54.23-.44,1.14-.4,1.21l.89-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3407",
    className: "cls-1",
    d: "M19.05,9.47l-.82-.26c.04.2.28.42.46.49.04-.04.22-.2.35-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3409",
    className: "cls-1",
    d: "M19.66,10.09c-.15.22-.2.28-.37.39.29,1.33-1.62,1.66-2.72,1.81-.01.18-.07.34-.12.48.2-.01,4.11-.09,3.2-2.68h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3411",
    className: "cls-21",
    d: "M19.68,10.11c.53,1.93-1.2,2.48-3.22,2.66-.05.12-.1.25-.15.38,2.75-.19,4.19-1.08,3.82-2.94-.18-.03-.32-.07-.45-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3413",
    className: "cls-10",
    d: "M6.83,23.62c.22.1.49.03.64,0,.08.08-.02.37.21.59-.13.06-.87-.17-.85-.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3415",
    className: "cls-10",
    d: "M6.52,22.03c.09.29.35.32.46.39,0,.11-.29.11-.3.51-.2-.02-.47-.48-.16-.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3417",
    className: "cls-10",
    d: "M7.99,24.46c.36.06.49-.13.57-.14.04.12.2.27.36.35-.07.26-.94.21-.92-.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3419",
    className: "cls-10",
    d: "M10.75,23.48s-.43,0-.51-.06c-.05.06-.07.27-.22.35.1.18.79.12.73-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3422",
    className: "cls-20",
    d: "M11.54,19.82c.06,0,.12-.02.17-.03-.24.29-.64.8-1.05,1.22-.41.43-.77.85-.63,1.23-.28-.28-.03-.55.35-1,.41-.49.88-1.05,1.16-1.43h0ZM11.03,22.92c0,.2-.17.38-.56.36.45-.49-.46-.52-.24-.73.6-.38.85.21.81.36ZM10.6,23.35c.13.03.21-.13.24-.05.06.16-.24.19-.24.05ZM7.55,21.64c-.09,0-.07.37-.61.35,0,0-.06,0-.09.05-.07.12.16.38.36.36.18-.01.32-.11.42-.24.04-.02.33-.18.31-.11-.34.17-.25.27.28.31.34-.05.63-.34.75-.4-.35.06-1.08-.17-1.25-.17-.02-.06-.07-.11-.15-.14,0,0,0,0,0,0h0ZM6.95,23.54s-.03.05-.05.07c.1.06.35.04.38.02-.03,0-.24-.01-.33-.09ZM9.48,22c-.46.22-.78,1.04-1.92.93-.03.1-.09.12-.15.15-.24,0-.51.05-.51.2,0,.18.28.29.47.27.19-.02.38-.2.39-.38h0s.02-.03.04-.03c1.27-.27,1.46-.92,1.7-1.15h0ZM9.68,22.02c-.05.31-1.05,1.22-1.09,1.52-.05-.04-.13-.07-.29-.06.09.46-.29.6-.39.52,0,.21.3.29.5.26.23-.04.42-.4.29-.61.03-.38.53-.49.74-.98.18,0,.21-.29.44-.34-.05-.15-.24.04-.19-.31h0ZM6.73,22.02c.03.18.11.26.25.37-.11-.04-.22-.07-.33-.17.11.03.03-.22.09-.2ZM9.12,21.53c.21.05.49.07.87.05-.55.19-.79.13-.87-.05ZM9.82,21.19s-.04.09-.09.12c.26,0,.52-.06.71-.27-.17.08-.37.15-.62.15ZM10.19,20.58s-.09.11-.14.16c.22.02.65-.08.84-.29-.17.08-.45.12-.7.12ZM10.7,20s-.17.17-.22.21c.22.02.71-.15.9-.36-.17.08-.43.15-.68.15ZM11.4,19.36c-.01.25-.1.41-.19.52.08-.02.15-.04.23-.08,0-.14-.02-.3-.04-.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3424",
    className: "cls-10",
    d: "M18.43,23.23c.22.05.48-.09.61-.09.06.12.08.24.33.33-.16.18-.76.24-.94-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3426",
    className: "cls-10",
    d: "M20.86,24.21c-.08.08-.17.16-.32.25.27.25.83-.03.8-.27-.05-.1-.21.11-.48.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3428",
    className: "cls-10",
    d: "M21.92,23.35c0,.32-.04.41-.07.52.16.11.56-.15.6-.52-.04-.09-.21.07-.52,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3430",
    className: "cls-10",
    d: "M22.66,21.56c-.12.03-.05.42-.18.55.11.06.18.2.26.33.25-.19.24-.74-.08-.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3432",
    className: "cls-20",
    d: "M18.71,23.19c.12-.04.25-.1.3-.08.07-.26-.1-.11-.3.08ZM18.54,22.98c.24,0,.57.04.66-.28.37.18.76-.16.67-.48,0,0-.12.54-.88.2-.15-.02-.36.07-.35.18.01.13.27.25-.09.38h0ZM20.56,22.72c.19.2.32.38.28.53.12-.17.13-.07.16,0,.14.11.25.45-.11.66.17.05.18.2,0,.25,0,.16.43-.04.47.03.03-.01.04-.06.05-.11.04-.05.04-.1,0-.17.27-.45-.07-.7-.36-.75-.18-.19-.33-.3-.49-.42h0ZM20.57,22.22c.29.18.69.33,1.06.57.38-.37.65.24.11.28.14.25.71.23.69.03.36-.68-.61-.84-.8-.6-.29-.17-.56-.35-.98-.43.83.36.98.47.83.49-.13.02-.6-.25-.92-.35ZM20.83,21.7c.23-.1.72-.09.86-.21.22-.4.62-.29.75-.03.09,0,.16.02.17.09-.09.19-.03.65-.27.54.04-.03.02-.07,0-.1-.1.1-.1-.01-.1-.06-.15.18-.23.15-.34.12.03-.01.04-.04.04-.09.45-.17.06-.7-.3-.21-.12.04-.61-.07-.8-.05h0ZM17.24,19.18l-.02.05c.18.17,1.78,1.93,2.26,2.68-.07-.16-.04-.23-.32-.56.72.41,1.08.05,1.04-.03-.06,0-.1.02-.13,0-.67.34-1.16-.22-1.46-.6.37.3.62.35,1.01.37.04-.07.04-.1.05-.14-.03,0-.07-.02-.09-.04-.45.17-1-.17-1.43-.75.41.29.7.26.97.27.04-.05.1-.09.11-.15-.04,0-.07-.01-.1-.02-.29.1-.98.07-1.32-.52.23.16.49.25.82.17.07-.05.14-.1.15-.16-.41.1-.81.1-1.17-.22.1,0,.21-.04.32-.09-.21.02-.44,0-.7-.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3434",
    className: "cls-2",
    d: "M12.28,6.65c.79.42,1.71-.55,2.35-.02.07,0,.08-.05.07-.09-.75-.67-1.54.32-2.42.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3436",
    className: "cls-2",
    d: "M12,18.84l-.06.07c-.08.35-.26.63-.47.89.19.03.43-.08.66-.18-.14-.27-.17-.44-.13-.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3438",
    className: "cls-20",
    d: "M12.22,18.38c.11.22.32-.14.42-.24-.13.47-.4.95.18,1.4-.3.03-.38.16-.1.45-.53-.26-.84-.7-.5-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3440",
    className: "cls-22",
    d: "M12.66,18.12c-.18.94.12,1.3.42,1.39-.12-1.01.29-1.73.85-2.29-.04-.94-.17-1.37-.27-2.05,0,.31.23,1.18.08,1.78-.16.63-.61,1.24-1.08,1.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3442",
    className: "cls-2",
    d: "M10.8,19.09c.53.04.96-.13,1.31-.49-.19.47-.63.69-1.28.62.24-.04.24-.08-.03-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3444",
    className: "cls-2",
    d: "M10.74,18.55c-.05.08-.09.12-.13.16.84.11,1.31-.29,1.62-.64.46.03.78-.27,1.06-.58-.31.25-.63.45-1,.41-.36.52-.86.76-1.55.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3446",
    className: "cls-2",
    d: "M11.06,17.91c-.06.13-.08.13-.12.17.28.06.67-.05,1.34-.6.66-.02.93-.45,1.12-.63-.35.3-.7.46-1.06.47-.35.36-.73.64-1.28.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3448",
    className: "cls-2",
    d: "M11.28,17.39l-.12.19c.23-.01.53,0,1.17-.59.49-.1.93-.47,1.32-1.12-.32.4-.62.82-1.27.88-.17.38-.6.54-1.11.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3450",
    className: "cls-2",
    d: "M16.68,18.17c-.04.34-.12.65-.27.88.02.11.01.22,0,.33.23-.23.4-.9.26-1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3452",
    className: "cls-2",
    d: "M17.02,18.33c.25.64.03,1.5-.76,1.64.24.1.98-.23,1.08-1.23l.6.68c.03-.16.05-.31-.06-.54-.48-.1-.63-.29-.86-.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3454",
    className: "cls-8",
    d: "M17.41,18.54c.32.14.89.35,1.45.1.08.03.17.06.25.08-.19.2-.73.25-1.23.18.68-.09-.35-.17-.48-.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3456",
    className: "cls-30",
    d: "M16.28,17.39c.23.17.5.27.8.26.22.42.87.54,1.24.52.02.06.06.11.1.16-.31,0-.7-.1-1.3-.48-.16-.06-.73-.32-.84-.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3458",
    className: "cls-2",
    d: "M16.16,16.76c.23.19.49.3.77.33.28.3.62.46,1.05.51l.09.16c-.14.01-.8-.28-1.05-.51-.41-.1-.71-.3-.87-.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3460",
    className: "cls-2",
    d: "M16.21,16.25c.27.27.58.37.83.37.19.2.36.4.75.5.02.05.04.1.07.13-.3,0-.7-.42-.75-.48-.4-.06-.85-.26-.9-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3462",
    className: "cls-20",
    d: "M13.85,15.05c.09-.03.13-.08.17-.13.07.1.17.12.27.15-.19,0-.21.08-.12.24.04.06.11,1,.12,1.57,0,.53.07.87.18,1.09-.42-.35-.18-2.46-.62-2.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3464",
    className: "cls-22",
    d: "M14.54,15.09c.23-.02.46-.03.74-.2l.1.12c-.2.43-.31,1.45-.44,2.36.04-.58.05-1.1.02-1.25-.06-.33-.05-.53-.04-.58.13-.46-.22-.34-.37-.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3466",
    className: "cls-2",
    d: "M15.47,15.05l.03.03c-.39.85,0,2.81-.84,3.8l-.02-.38c.64-.42.48-2.58.83-3.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3468",
    className: "cls-2",
    d: "M14.06,17.16c0,1.4.23,1.66-.73,2.83.44-.37.94-1.5.88-.85.11-.21.22-.41.25-.59-.37-.63-.35-.99-.4-1.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3470",
    className: "cls-2",
    d: "M14.83,18.7l-.18.21.05,1.85c.02-.77.06-1.47.13-2.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3472",
    className: "cls-20",
    d: "M15.25,17.36c-.05.29-.08.63-.16.82.13,1.48.53,1.62.87,1.75-.56-.79-.67-1.85-.71-2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3474",
    className: "cls-6",
    d: "M14.18,19.3c-.17.39-.12,1.14-.6,1.63.4-.21.56-.71.57-1.1l.04.41c-.13.85-.52,1.08-.79,1.13.04-.01.46.08.85-.78.01.31-.21.66-.49.78.25,0,.5-.22.62-.4-.2-.6-.21-1.14-.2-1.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3476",
    className: "cls-2",
    d: "M14.37,20.57c.04.2.1.5.33.78l.02.36c.1-.14.51-1.28.52-1.66.02-.12.02-.26.11-.17.01,0,.02,0,.03,0-.12-.08-.25-.5-.35-.63.07.45.13,1.08-.33,2.02-.14-.16-.24-.43-.33-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3478",
    className: "cls-20",
    d: "M16.32,21.29c-.49.25-.91-.36-1.12-.73l.09-.52s.04-.03.05,0c.08.57.44,1.23.97,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3480",
    className: "cls-11",
    d: "M15.11,20.76l-.05.16c.19.42.41.57.7.67-.57-.28-.61-.56-.65-.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3482",
    className: "cls-20",
    d: "M14.57,21.48l.15.26.11-.25c-.02.69-.07,1.51-.09,2.28-.06-.77-.15-1.56-.18-2.28h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3484",
    className: "cls-2",
    d: "M15.01,21.05s-.03.08-.04.1c.51,1.88-.09,2.88-.22,3.03-.35-.62-.35-1.24-.42-1.76.05.47,0,1.08.4,1.85v.31c.5-.62.81-1.48.42-3.35-.06-.05-.09-.12-.13-.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3486",
    className: "cls-20",
    d: "M14.56,24.4c.04.07.08.14.16.2.11-.11.13-.17.18-.25-.09.5-.13.98-.2,1.48-.05-.49-.08-1.02-.15-1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3488",
    className: "cls-2",
    d: "M15.45,24.48c-.11-.24-.23-.45-.15-.71-.02-.08-.05-.09-.09-.11-.02.14-.07.24-.12.34.19,1.14-.08,1.76-.39,2.27-.51-.69-.42-1.44-.43-2.08-.15,1.3.16,1.87.42,2.16v.32c.74-1.08.66-2.08.5-2.55.08.12.15.25.26.36h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3490",
    className: "cls-32",
    d: "M12.67,21.21c.1.94,1.29.66,1.78-.06l-.04-.13c-.45.59-1.42,1.11-1.73.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3492",
    className: "cls-20",
    d: "M14.34,21.55c-.44.91-.97,1.56-1.69,1.62.5.04,1.03-.36,1.19-.54.12-.21.27-.28.12,0-.06.1-.12.17-.21.26.12-.05.36-.42.41-.46.02-.39.11-.61.18-.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3494",
    className: "cls-13",
    d: "M14.16,22.47c0,.1-.02.21-.02.29-.69.71-1.29.93-1.92.79.52.01,1.13.07,1.94-1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3496",
    className: "cls-20",
    d: "M11.92,22.88c-.15-.38-.1-.68.17-.91-.54-.01-1.13,1-.13,1.51-.5-.29-.53-.91-.36-1.11.11-.17.27-.22.16-.03-.08.32.06.48.16.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3498",
    className: "cls-20",
    d: "M15.17,21.28c.1.16.23.31.39.41-.05.92.97,1.53,1.65,1.27-.39.29-1.69.22-2.05-1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3500",
    className: "cls-4",
    d: "M15.32,22.44v.11c.48.79,1.28.82,1.52.79-.75-.01-1.21-.36-1.52-.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3502",
    className: "cls-12",
    d: "M17.39,21.86c.63.44.46,1.12-.22,1.4.52-.34.78-.79.22-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3504",
    className: "cls-2",
    d: "M16.65,23.46c.6.11,1.61-.36,1.07-1.41.55.64-.07,1.78-1.07,1.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3506",
    className: "cls-26",
    d: "M15.32,23.07c0,.06,0,.1-.02.19.51,1.02.8,1.09,1.13,1.36-.62-.46-.94-.99-1.11-1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3508",
    className: "cls-28",
    d: "M16.16,24.99c.11.05.19.01.28.04.78.27,1.76-.19,1.46-1.14.51.5-.43,1.94-1.75,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3510",
    className: "cls-13",
    d: "M17.54,23.62c.59.59-.02,1.4-.81,1.13.84.11,1.15-.58.81-1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3512",
    className: "cls-20",
    d: "M11.77,23.62c-.81.54-.36,1.2.01,1.35-.14-.11-.3-.47.15-.27.15.06.28.07.4.06-.83-.27-.65-.72-.56-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3514",
    className: "cls-20",
    d: "M14.15,22.87c.02.28.05.5.09.68-.26.52-.58.87-.9,1.12.38-.37.67-.74.8-1.13-.66,1.03-1.12,1.19-1.6,1.22.59-.13,1.45-.64,1.6-1.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3516",
    className: "cls-5",
    d: "M14.25,23.58c.02.08.04.17.09.23-.83,1.61-1.95,1.56-2.33,1.43.72.07.47-.06.24-.1.86.03,1.61-.55,2.01-1.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3518",
    className: "cls-23",
    d: "M13.56,14.73c.11-.07.16-.16.22-.25.02.04.07.08.12.12-.16.05-.21.28-.3.29-.01-.05-.01-.11-.04-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3520",
    className: "cls-2",
    d: "M13.91,14.61c.24.09.48.08.78-.13.03.03.06.06.1.09-.28.2-.75.15-.88.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3522",
    className: "cls-2",
    d: "M14.92,14.6c.17.03.33.07.55-.05.03.04.06.08.09.11-.07.07-.43.06-.65-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3524",
    className: "cls-2",
    d: "M15.61,14.16c.05.03.15.13.24.19-.07.1-.14.21-.21.33-.31-.27-.09-.55-.04-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3526",
    className: "cls-2",
    d: "M13.34,14.23c.04.06.08.11.1.15.19-.13.25-.27.32-.42-.03-.02-.05-.04-.08-.08-.15.27-.24.3-.34.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3528",
    className: "cls-2",
    d: "M13.78,13.97l-.02.04c.38.22.99.38,1.76-.02l-.08-.16c-.5.39-1.07.46-1.66.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3530",
    className: "cls-2",
    d: "M15.58,13.97c.22-.04.14-.32.35-.4.34.51.91.37,1.14,0l.04.28c-.22.14-.52.39-1,.16-.04.08-.05.21-.05.35-.21-.07-.39-.18-.48-.38h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3532",
    className: "cls-2",
    d: "M16.26,13.03c.09.16,0,.54,0,.66-.16-.02-.25-.16-.34-.27.02,0,.03,0,.04-.02.02-.1.21-.15.3-.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3534",
    className: "cls-13",
    d: "M14.79,13.5l-.02.02c.26.09.79.14,1.17-.12l-.07-.12c-.27.23-.61.33-1.09.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3536",
    className: "cls-2",
    d: "M14.64,13.41s.09.07.13.08c-.35.32-.86.24-1.38-.04,0-.02,0-.03,0-.05.59.32,1.01.23,1.25,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3538",
    className: "cls-5",
    d: "M13.36,13.41c.13.2-.19.26-.19.56l-.12-.16c0-.19.25-.16.32-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3540",
    className: "cls-5",
    d: "M13.02,13.75l-.24-.37c-.26-.33.59-.4.5-1.02.05.04.11.1.16.13-.03.5-.47.49-.48.83-.06-.02-.08-.07-.1-.14-.02.02-.03.02-.05.04-.11.13.05.21.21.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3542",
    className: "cls-2",
    d: "M13.25,13.07c.25.04.49,0,.72-.22.04.04.07.08.12.11-.3.18-.69.2-.85.11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3545",
    className: "cls-23",
    d: "M14.11,12.97l-.03.02c.41.23.98.23,1.29.02-.04-.03-.08-.06-.12-.09-.37.27-.92.18-1.14.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3547",
    className: "cls-32",
    d: "M15.38,13.02l-.02.03c.29.11.65.1.9-.03-.02-.05-.04-.09-.07-.13-.27.22-.54.2-.81.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3549",
    className: "cls-32",
    d: "M13.48,12.51c.43.22.89.07,1.15-.15.04.06.09.09.13.12-.32.28-1.14.24-1.28.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3551",
    className: "cls-2",
    d: "M14.77,12.48l-.02.02c.39.26.97.1,1.13,0-.02-.06-.04-.12-.06-.16-.27.23-.67.31-1.05.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3553",
    className: "cls-2",
    d: "M12.4,11.94l.06.03c.06-.08.11-.1.13-.07.02.03-.02.1.04.15.2-.16.66-.26.71-.5.08.23.37.24.6.65-.05-.31-.37-.39-.5-.6-.13-.21-.05-.47.05-.8-.22.29-.05.71-.4.89-.22.12-.65.09-.69.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3555",
    className: "cls-2",
    d: "M14.24,10.47v.28c-.35.14-.07,1.06-.21,1.26-.06-.78-.38-1.06.21-1.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3557",
    className: "cls-2",
    d: "M14.54,11.13h.04c.05.51.58.56.68,1.06-.11-.35-.42-.45-.58-.64-.09.39-.56.51-.68.73-.03-.18.65-.44.54-1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3559",
    className: "cls-2",
    d: "M15.35,10.64c-.28.44.28.73-.02,1.47.16-.97-.52-.89-.09-1.59.15.14.66.29.7.53-.17-.24-.43-.26-.59-.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3561",
    className: "cls-2",
    d: "M15.93,11.12c.05.17.1.24.14.35-.15.5-.76.68-.79.86-.1-.23.66-.37.65-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3563",
    className: "cls-2",
    d: "M16.51,10.61c-.1-.02-.19,0-.29-.11.02.16,0,.26-.03.36.2.11.33,1.18.41,1.23-.04-.46-.02-1.06-.3-1.39v-.06c.1.03.16.02.21-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3565",
    className: "cls-2",
    d: "M12.78,11.44c.19-.29.36-.62.6-.79.24-.17.4-.11.89-.51l.19-.49c-.41.61-.9,1.03-1.61.88.04.02.07.08.36.1-.15.15-.28.46-.42.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3567",
    className: "cls-20",
    d: "M12.68,10.1c.37.19.82.28,1.6-.83.17-.05.33-.14.48-.3-.5,1.2-1.92,1.94-2.08,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3569",
    className: "cls-17",
    d: "M14.34,10.79c.59-2.24,2.4-3.58.84-4.77,1.13,1.96-.67,2.79-.84,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3571",
    className: "cls-20",
    d: "M13.91,8.85c.03.59.77.15.95-.23-.3.2-.6.39-.95.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3573",
    className: "cls-20",
    d: "M15.03,7.94c.07-.1.08,0,.2.02-.27.57-.73.72-.98.73.34-.18.65-.38.79-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3575",
    className: "cls-2",
    d: "M14.84,6.99l.06.06c.08,0,.16,0,.25-.08,0,.07-.03.1-.06.12.05.41,0,.65-.06.84.07-.07.13.03.19.03.1-.16.28-.72,0-1.21,0,.14-.14.28-.38.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3577",
    className: "cls-2",
    d: "M13.88,6.81c.45-.18.71.14.91.17.32.47-.01.88-.23,1.14.14-.25.35-1.23-.68-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3579",
    className: "cls-22",
    d: "M14.28,11.05c.49.23.72-.33.95-.54-.12-.27-.08-.48-.09-.71-.43.23-.41,1.07-.86,1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3581",
    className: "cls-22",
    d: "M15.96,7.1s-.04.18-.1.17c-.03,1.13-1.06,1.76-1.3,3.39.15-.17.26-.86.64-1.5.4-.66.8-1.03.76-2.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3583",
    className: "cls-20",
    d: "M15.43,9.24c-.41,1.1.4,1.11.47,1.47-.84-.28-.9-.9-.47-1.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3585",
    className: "cls-20",
    d: "M15.58,6.07c1.36.88.19,2.67-.32,3.15.2-.45,1.43-1.69.32-3.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3587",
    className: "cls-22",
    d: "M16.04,5.58c.14.26.36.66.03.58.58,1.28-.06,1.94-.37,2.66-.67,1.75.44,1.06.31,2.28.38-.44-.11-1.08-.09-1.3-.03-.32.17-1.01.24-1.43.08.23.2.37.35.46-.26-.91.55-2.7-.47-3.24h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3589",
    className: "cls-22",
    d: "M16.17,8.59c.07.09.11.19.22.26.05.36-.45,1.48.31,1.57-.61.31-.95-.57-.52-1.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3591",
    className: "cls-2",
    d: "M15.84,5.23c.13,0,.43.22.72,0,.2.27-.17.49-.55.29-.1-.06.22-.09-.17-.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3593",
    className: "cls-20",
    d: "M13.57,5.33c.12.13.23.19.34.5.08,0,.16.01.24.03-.13-.21-.3-.41-.58-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3595",
    className: "cls-2",
    d: "M14.81,4.96c1.18.32,1.07-.23,1.28-.31.21.34-.37.77-1.28.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3597",
    className: "cls-5",
    d: "M13.36,5.19c-.07-.02-.13-.02-.17-.01.11-.85,1.05-.31,1.55,0-.64-.31-1.44-.7-1.38,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3599",
    className: "cls-17",
    d: "M13.37,5.19c-.05-.96,1.34.14,1.98.18-.45.05-1.92-.93-1.91-.16l-.07-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3601",
    className: "cls-2",
    d: "M13.46,5.22l.12.04c.01-.08.04-.18.09-.19.27-.05.02.09.06.13.05.04.11.07.17.11,0-.04,0-.09,0-.15,0-.22.64.13,1.08.28.05.13-.25.3-.48.25.21.17.65.09.85-.19.34.03.42-.03.49-.11-.26-.05-.38.07-1.03-.11-.6-.17-1.33-.68-1.35-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3603",
    className: "cls-24",
    d: "M14,5.11c.07,0,.14.02.21.05-.13.21.06.4.17.37.04.03.07.07.2.1-.18.04-.76-.14-.58-.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3665",
    className: "cls-10",
    d: "M12.45,6.3c-.66-1.26,1.24-1.49,1.44-.44,0,0,.47.02.89.24.81.59.32.92.15.9-.38,0-.45-.36-1-.22-.13.05-.14.12-.2.12-.33-.08.27-.74.92-.27.06.04.18-.04.07-.16-.43-.44-1.19-.2-1.35-.16-.21-.34-.67-.26-.92,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3605",
    className: "cls-25",
    d: "M14.33,5.27c.08.07.5.13.51.17-.13.32-.57.22-.51-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3607",
    className: "cls-2",
    d: "M17.14,13.83s0,0,0,.02c.1.05.22.08.37.09l.34,2.03c-.03-.53-.06-1.07-.08-1.58-.04-.1-.07-.28-.09-.45.04,0,.09-.01.13-.02.22,1.28.75,1.54.85,1.64-.28-.3-.66-.71-.79-1.67.19-.11.27-.23.34-.25.02-.05,0-.18-.02-.24-.19.18-.36.39-.74.36-.03,0,0,.04,0,.04.15.2-.15.08-.31.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3609",
    className: "cls-22",
    d: "M17.87,16.18l.02.31c.19-.12.37-.16.62-.75.1,1.04.12,2.05.72,2.25-.31-.71-.31-1.5-.34-2.25-.04.05-.07.08-.11.11-.25-.14-.33-.26-.46-.39-.08.26-.13.53-.46.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3611",
    className: "cls-20",
    d: "M18.32,13.68c.08.03.18.04.28.04l.11,1.51-.38-1.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3613",
    className: "cls-2",
    d: "M19.04,13.57l.05-.04c.12.28.29.52.53.71l.65,4.38-.94-4.39c0,.76-.21,1.26-.55,1.6l-.04-.29c.36-.48.57-1.06.3-1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3615",
    className: "cls-32",
    d: "M20.03,14.57c.1.06.21.11.34.15.39,1.32.54,3.92.03,4.87l-.04-.36c-.91-.69-1.13-2.63-1.32-3.71l.03-.05c.18.99.38,2.89,1.27,3.67.16-.51.51-1.97-.11-4.4-.05-.05-.12-.1-.19-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3617",
    className: "cls-20",
    d: "M19.48,13.16c.08,0,.12,0,.25-.03l.87,1.29-1.11-1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3619",
    className: "cls-20",
    d: "M20.41,14.73c.13.04.28.08.45.11,0,.04,1.27,3.28,2.15,3.53-1.13.22-1.69-1.75-2.43-2.92-.05-.25-.11-.49-.17-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3621",
    className: "cls-2",
    d: "M20.26,12.78s-.02.03-.04.04c.51.79.53,1.28.46,1.71l.21.27c.1-.61,0-1.06-.15-1.48l2.55,3.71-2.26-3.61.48.07c-.4-.13-.8-.18-1.25-.71h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3623",
    className: "cls-2",
    d: "M21.8,13.5c.1,0,.19,0,.25-.03.51.82,1.81,2.32,1.66,4.36l-.16-.31c-1.21-.28-2.05-1.8-2.48-2.42.71.93,1.51,2.15,2.45,2.35.08-1.52-1.07-3.01-1.72-3.95h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3625",
    className: "cls-20",
    d: "M22.07,13.47l.04.08c1.12.6,2.38,1.78,3.16.91-.81.32-2.11-.81-2.97-1.24l.04.19c-.1.05-.18.06-.26.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3627",
    className: "cls-20",
    d: "M20.48,12.08s0,.06,0,.08l1.39.86-1.27-1.01s-.07.05-.11.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3629",
    className: "cls-2",
    d: "M22.22,12.89c.02.09.05.18.07.28,1.67.77,2.67.58,3.15.28l-.26-.09c-.73.49-2.51-.17-2.96-.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3631",
    className: "cls-2",
    d: "M20.89,11.57s0,.04-.02.07c.71.37,1.2,1.07,1.18,1.54l.24.2c-.09-.8-.38-1.1-.67-1.39l3.39,1.33-3.29-1.54c.44-.1.9-.12,1.27-.58l.78-.03c.66-.1,1.41-.48,1.49-.84l-.25.03c-.32.7-1.57.68-2.22.7-.3.56-1.26.61-1.91.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3633",
    className: "cls-20",
    d: "M22.79,11.42c-.08.07-.17.12-.27.16.35.07.68.17.99.29.88.09,1.74-.04,1.78-.79-.37.59-1.42.48-2.5.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3635",
    className: "cls-20",
    d: "M20.88,10.9c.02.07.03.14.05.21l1.8-.05c-.61-.05-1.24-.1-1.84-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3637",
    className: "cls-2",
    d: "M21.74,10.17c.37.17.7.35.97.56l-.24-.22c.77-.06,1.55-.12,2.41-.17l-2.73-.02-.41-.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3639",
    className: "cls-2",
    d: "M21.17,10.24s-.03.08-.04.11l.6-.17c.9-.64.94-.97,1.05-1.31l1.37-.85-1.56.77c-.84,0-1.06.13-1.32.19.72-.16,1.19-.18,1.45-.1l-.17.1c-.22.71-1.02,1.13-1.39,1.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3641",
    className: "cls-20",
    d: "M21.16,9.65s.03.1.04.15c.43-.23.83-.49,1.23-.75-.42.21-.85.42-1.27.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3643",
    className: "cls-20",
    d: "M22.32,9.74c.48-.04.97-.05,1.48-.01.12-.07,1.34-.42,1.04-1.07-.35.71-1.66.95-1.76,1.01-.21.02-.71.04-.76.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3645",
    className: "cls-16",
    d: "M24.33,7.92l.27-.12c.03.05-.17.42-.51.81-.45.5-.72.72-1.58.88.02-.02.03-.05.05-.07.67-.18,1.59-.83,1.78-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3647",
    className: "cls-20",
    d: "M21.46,8.63l-.08.12c.77-.55,1.38-.89,1.84-1.04.46-.49.57-.97.37-1.25.03.9-1.4,1.57-2.14,2.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3649",
    className: "cls-5",
    d: "M20.97,8.97l-.03.23c.57-.42.88-1.17.8-1.81l-.2.21-.89.72s.1.09.13.13l.75-.83c.05.68-.41,1.21-.56,1.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3651",
    className: "cls-20",
    d: "M21.74,7.91l-.05.19c.37-.23.62-.47.85-.72.64-.74.72-1.38.77-1.69l-.27.22c.04.94-1.01,1.84-1.3,2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3653",
    className: "cls-2",
    d: "M21.43,7.38c.11,0,.21,0,.32,0l1.25-1.43-1.57,1.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3655",
    className: "cls-2",
    d: "M20.51,6.57l-.15.18c.07.35.06.83-.46,1.4l.02.03h.04c.41-.53.85-.66,1.28-.79-.25.06-.51.1-.79.25.19-.59.11-.89.07-1.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3657",
    className: "cls-20",
    d: "M20.57,7.04v.11c.44-.27.9-.61,1.3-1.06.24-.31.54-.74.58-1.32l-.23.18c-.05.97-1.3,1.81-1.65,2.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3659",
    className: "cls-20",
    d: "M19.55,6.91c.36-.16.72-.3.96-.35l1.57-1.46c-.42.3-1.3,1.07-1.72,1.38-.14.11-.29.1-.81.43h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3661",
    className: "cls-17",
    d: "M22.17,4.96c-3.97.69-6.18,5.49-3.52,5.06l-.15-.04c-.53.05-.67-.42-.62-.71.05-.32.35-.5.44-.53-.02-.28-.03-.56.24-.8.11-.27.24-.41.36-.54.42-1.51,2.53-2.27,3.24-2.44h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3663",
    className: "cls-2",
    d: "M20.32,6.73c-.5.07-1.18.62-1.28.85-.01.02,0,.06-.17.15v.03c.18-.07.64,0,.21.11.28,0,.53.1.7.48.92-.14,1.15.53.92.98.61.52.22,1.2-.11,1.33.2.45.31,1.05-.31,1.28,0,.4-.06,1.02-1.01,1.02-.11.27-.45.73-1.02.49,0,0,0,.02,0,.03,0,.03.24.09.24.08.19.02.22.15-.02.09-.09-.03-.16-.05-.22-.08h0s0,.04-.01.06c.62.21.97-.16,1.17-.48.74-.04,1.04-.44,1.08-1.08.6-.38.52-.95.33-1.34.54-.4.5-1.11.09-1.44.28-.93-.55-1.18-.99-1.11-.15-.25-.24-.28-.35-.35l.78-1.06-.95.97c-.09-.03-.22-.05-.37-.04.2-.5.99-.89,1.3-.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3667",
    className: "cls-3",
    d: "M13.08,5.63c.12.18.32-.05.65.3l.04-.02c-.07-.3-.28-.48-.58-.51.13.11.03.12.03.19,0,.06,0,.14-.14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3669",
    className: "cls-3",
    d: "M12.55,6.17c.18-.1.57-.24.82.11.78-.23,1.34-.02,1.42.3.05-.09-.17-.56-1.07-.48-.76-.53-1.2-.05-1.17.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3671",
    className: "cls-15",
    d: "M13.75,6.84c-.14,0,.29-.51.98-.03.25.1.37-.03.32-.23-.02-.15-.1-.23-.15-.35.35.26.39.59.16.72-.37.18-.63-.47-1.31-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3673",
    className: "cls-2",
    d: "M13.17,13.99l.15.22-.04-.03c-.44.21-.66.13-.88.03l-.02-.02c-.45.09-.73-.03-.97-.21.02.13.11.24.23.33l-.47,2.06.23-1.94c-.27.76-.62,1.11-1.11,1.32l.04-.21c.45-.23.83-.66,1-1.59-.18.02-.36.05-.54,0l-.44,1.53.21-1.58c-.19-.13-.35-.29-.51-.45v-.03c.05.07.1-.14.09-.2.33.54.81.64,1.26.49,0,.05,0,.1-.02.17h.02s.03-.05.04-.1c-.01,0-.02-.03-.02-.05v-.02c.26.46.89.24.97.28,0,.02,0,.09.02.15v.02s.02-.06.02-.11l-.02-.04h.02c.22.17.51.16.76-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3675",
    className: "cls-27",
    d: "M11.71,14.36c.14.07.3.12.46.16-.08.97-.57,2.07-1.08,2.4v-.27c-.11-.21-.21-.55-.24-1.24l.04-.04c.01.48.06.93.22,1.26.25-.18.78-.8.86-1.98,0-.07-.02-.12-.06-.14-.1-.05-.15-.1-.21-.14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3677",
    className: "cls-2",
    d: "M9.84,18.45c.56.15.93-.93,1.14-1.65-.1-.19-.24-.4-.25-1.28l-.05.05c-.06,1.13-.07,2.38-.85,2.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3679",
    className: "cls-31",
    d: "M10.11,13.53l.03.03c-.04.21-.33.99.03,1.74-.2-.29-.37-.76-.06-1.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3681",
    className: "cls-2",
    d: "M9.81,14.01l-.11.17-1.19,4.81,1.26-4.01c.06.23.14.48.47.86-.46,1.64-1.19,3.1-1.82,3.48l.06-.2c-.27-.81-.05-2.51.4-4.22-.29.94-.89,2.99-.51,4.49l-.12.37c1.24-.85,1.98-2.98,2.25-4.06-.07.05-.14.08-.22.11-.39-.35-.58-.91-.47-1.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3683",
    className: "cls-2",
    d: "M9.06,12.66c.03.15.2.32.29.47.05.08.1.11.16.02l.05-.08c.13.15.31.22.57.18l-.31.72c-.36.7-.84.85-1.32,1.02l.15-.27c.62-.06,1.07-.67,1.3-1.24-.16-.03-.31-.1-.48-.21l-.74,1.28.49-1.29c.1-.2-.16-.36-.16-.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3685",
    className: "cls-22",
    d: "M8.76,14.89c-.09.04-.18.07-.27.1-.8,1.79-1.25,3.39-2.68,3.89,1.29.25,2.17-1.83,2.48-2.45.23-.56.37-1.09.47-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3687",
    className: "cls-14",
    d: "M8.94,12.71c-.15.17-.64.87-.33,2.02l.03-.03c-.22-.77,0-1.62.3-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3689",
    className: "cls-2",
    d: "M8.41,13.73c-.04.3-.03.54-.01.77-.97,1.72-2.59,3.31-3.53,3.37,1.19-1.6,2.39-3.25,3.58-4.87.08-.03.15-.09.23-.14-.13.18-.18.34-.21.47l-3.28,4.21c1.1-.09,2.89-2.69,3.16-3.39,0-.21.03-.32.06-.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3691",
    className: "cls-16",
    d: "M5.07,17.6l.08-.1c-.09-1.62,1.74-3.55,2.24-4.16-.08.18-2.43,2.23-2.32,4.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3693",
    className: "cls-20",
    d: "M3.74,14.69c.28.43.74.7,2.47-.35.35-.38.69-.78,1.04-1.11h-.08c-.58.24-2.09,1.82-3.43,1.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3695",
    className: "cls-2",
    d: "M8.25,11.65c-.22.09-1.08.4-1.17,1.37l-.19.1c1.17.39,2.06-.49,2.24-.66-.18-.12-.37-.21-.52-.49l-.15.07c-.38.31-.83.62-1.27.91l1.36-.69c.08.09.17.18.36.3-.82.57-1.47.54-1.78.46.05-.56.38-1.03,1.13-1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3697",
    className: "cls-22",
    d: "M6.94,12.8c-.03.12-.06.24-.05.33-.37.15-.78.26-1.25.34-.03,0-.15.05-.19-.03-.05-.03-.11-.04-.18-.04-.01-.03-.07-.02-.08-.04,1.13-.2,1.65-.47,1.74-.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3699",
    className: "cls-11",
    d: "M5.67,11.96c-.3.15-1.54.81-1.75,1.44.6.18,1.06.02,1.33,0-.01-.02-.06-.01-.07-.04-.45.07-.99.1-1.14,0l.11-.06c.03-.54,1.31-1.21,1.52-1.34h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3701",
    className: "cls-2",
    d: "M4.22,13.29c2.02-.75,3-1.35,4.08-1.72v.04c-.09.05-.8.22-1.07.62l-3.01,1.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3703",
    className: "cls-2",
    d: "M7.95,11.68c-.14.06-.28.11-.42.18-.66-.1-.77-.26-1.05-.4l.06-.02c.1.08.23.14.36.2.19.07.24-.01.05-.08-.23-.07-.38-.17-.5-.27.23-.44.76-.65.83-.68-.3.19-.64.36-.73.66.46-.07.95-.15,1.55-.28.05.08.09.16.18.27v.02s-.1-.11-.1-.11l-1.61.12c.45.31.92.33,1.4.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3705",
    className: "cls-20",
    d: "M3.81,11.07c.19.62,1.75.46,2.67.4l.05-.02c-.07-.05-.14-.1-.18-.16-.38-.08-2.13.29-2.54-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3707",
    className: "cls-20",
    d: "M6.75,10.73l.02.02c-.11.09-.22.17-.33.3-1.45,0-2.35-.57-2.61-.91.36-.29.81-.39,1.28-.44-.41.12-.89.19-1.11.45h-.1c.67.75,2.46,1.08,2.85.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3709",
    className: "cls-2",
    d: "M4.1,10.17c.96.14,1.9.25,2.88.41.13-.12.37-.19.75-.22-.13,0-.23-.02-.43.01-1.1.02-2.14-.12-3.2-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3711",
    className: "cls-2",
    d: "M8.22,10.03c-.09.09-.14.23-.17.38-1.06-.34-1.23-1.01-1.26-1.07.63-.44,1.02-.28,1.54-.29-1.12-.05-1.41.24-1.46.3.42.12.72.22,1.62.37-.09.06-.14.12-.18.17-.35-.14-.99-.34-1.45-.52.07.31.54.76.94.88.11.03.23.08.27-.06.02-.06.1-.15.15-.17h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3713",
    className: "cls-20",
    d: "M4.2,8.64c.2.2.97.87,2.38.7.05.14.11.19.16.24-.37-.06-.75-.1-1.13-.07-.62-.19-1.18-.41-1.41-.88h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3715",
    className: "cls-20",
    d: "M7.07,8.93s.04.03.07.03c-.23.09-.41.19-.55.3-.71-.22-1.72-.74-2.08-1.4.44-.2,1.19-.11,1.62,0-.48,0-1.05-.1-1.34.09l-.22-.08c.09.28,1.6,1.6,2.5,1.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3717",
    className: "cls-2",
    d: "M4.87,7.98c.9.32,1.76.63,2.48.93.22-.05.44-.04.66,0-.05-.05-.1-.09-.15-.16h-.02s.09.13.09.13c-1.22-.42-2.13-.64-3.06-.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3719",
    className: "cls-20",
    d: "M7.7,8.34c-.07-.13-.13-.26-.14-.45-.34.16-1.89-.51-2.26-1.35.03.74,1.35,1.32,2.4,1.81h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3721",
    className: "cls-2",
    d: "M8.6,8.8c-.05.05-.09.11-.15.15-.03.02-.06.02-.08,0-.55-.35-.66-.96-.64-1.08.42-.07,1.01-.06,1.81.44-.18-.04-.77-.48-1.73-.4-.02.33.23.96.79.89h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3723",
    className: "cls-2",
    d: "M7.89,7.96l.97.71c.13,0,.25,0,.38.06,0-.02.02-.06.04-.1-.53-.22-.92-.44-1.38-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3725",
    className: "cls-20",
    d: "M5.7,5.71l.26.15c-.03.59,1,1.72,2.16,1.81-.19.02-.4.01-.55.08-.55-.34-.91-.7-1.22-1.01-.06,0-.11-.15-.22-.1-.29-.38-.41-.68-.43-.93h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3727",
    className: "cls-23",
    d: "M7.39,6.16c-.39-.15-.74-.32-1.41-.3,1.04.76,1.61,1.23,2.38,1.82.35.05.69.21,1.03.34-.04-.09-.08-.19-.1-.28,0,.08,0,.16.05.24-.46-.13-2.33-1.46-3.25-2.06.35-.11.83.09,1.29.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3729",
    className: "cls-20",
    d: "M7.92,6.2c-.42-.37-.89-.78-.99-1.36.49.06,1.45.39,2.19.92-.69-.4-1.34-.69-1.88-.68-.04.48.4.8.68,1.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3731",
    className: "cls-2",
    d: "M7.28,5.09l-.02.02c.71.52,1.22,1.02,1.78,1.53.16.13.14.28.15.42.06-.07-.02-.3.11-.32.12-.02.56.21.59.17-1.05-.46-1.74-1.21-2.61-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3733",
    className: "cls-14",
    d: "M9.5,7.89c-.1-.16-.26-.66-.15-.99,1.35.29,1.57,1.35,1.6,1.56-.2-.77-.93-1.47-1.44-1.38.31.28.68.87.92,1.11-.11,0-.22.01-.3.04-.19-.02-.28.02-.37.05-.1-.12-.14-.21-.21-.31.14.19.33.16.54.1-.21-.38-.41-.65-.62-.97-.1.08,0,.48.03.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3735",
    className: "cls-20",
    d: "M10.05,6.46c2.29,1.52,2.47,4.02.84,3.61,1.94-.23-.33-3.12-.84-3.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3737",
    className: "cls-2",
    d: "M10.15,8.25c.19-.08.69-.07.72.71l-.17.12c0-.21.04-.69-.55-.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3739",
    className: "cls-2",
    d: "M10.7,9.09l.17-.13c.83.32.43,1.22-.16,1.08.69-.07.54-.96-.02-.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3741",
    className: "cls-3",
    d: "M13.39,3.25c.11.2-.2.79.34.7.18.12.35.05.43.05.36-.13.35-.37.37-.44-.31-.44.04-.52.08-.55.19.02.29.38.03.49.02.02.05.01.09,0,0,.57.4.61.68.52.55.15.28-.49.55-.97-.3.52-.11,1-.54.94.11-.27-.18-.48-.04-.77-.23.19.15.55,0,.74-.15.13-.3.02-.3-.04-.06-.19.38-.43.12-.78.09.19.06.28.01.4-.05.12-.24.23-.15.48-.19-.04-.29-.27-.24-.45.05-.18.14-.48-.19-.58-.43.13-.21.47-.16.53.1.11-.09.46-.33.45.11-.17-.02-.2-.18-.47-.01.14.32.33.13.45-.1.08-.24.03-.3-.02-.11-.12.15-.27.1-.51-.07.35-.17.33-.16.49-.13.04-.26.08-.3-.16,0-.33,0-.53-.05-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3743",
    className: "cls-3",
    d: "M15.62,4.59v.03c-.66.04-1.33-.08-1.98-.1v-.03c.66.02,1.18.13,1.98.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3745",
    className: "cls-3",
    d: "M14.59,4.71v.03c.38.06.76.12,1.08.09v-.03c-.38.05-.73-.03-1.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3747",
    className: "cls-9",
    d: "M13.68,4.16c-.11.03-.06.19,0,.19.12,0,.24.02.36,0,.07-.03.09-.15.01-.2-.13-.02-.25-.02-.38.01h0ZM13.66,4.14c.21-.04.4-.01.51,0,.1.03.1.19,0,.23-.11.01-.34,0-.51,0-.11-.09-.05-.19,0-.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3749",
    className: "cls-9",
    d: "M14.41,4.33c.27.04.5.06.45-.16-.08,0-.6-.12-.45.16ZM14.41,4.35s-.09-.12.01-.23c.15-.01.31,0,.47.02.15.06.13.19.01.24-.26,0-.39-.02-.49-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3751",
    className: "cls-9",
    d: "M15.15,4.37c.27.06.5.11.45-.11-.08,0-.59-.18-.45.11ZM15.14,4.39s-.08-.13.03-.22c.39.02.32.02.46.06.14.07.12.2,0,.24-.34,0-.39-.05-.49-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3753",
    className: "cls-2",
    d: "M10.24,8.61l-.43,1.26c.12,0,.22,0,.43-.04.19-.4.23-.96,0-1.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3755",
    className: "cls-1",
    d: "M10.59,11.08l-.78-1.2s-.2.5-.22.66c.1.26.55.53,1,.54h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3757",
    className: "cls-2",
    d: "M10.46,10.15c.27-.1.32-.26.33-.36l-.55.05c.08.1.16.2.22.31h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3759",
    className: "cls-2",
    d: "M9.56,9.24c-.11-.07-.47-.1-.54-.03l.46.42c.02-.12.04-.27.08-.39h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3761",
    className: "cls-2",
    d: "M8.53,10.54l1.28-.66s-.15.5-.21.66c-.15.08-.79.23-1.07,0h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseMobywatelIcon);
export default __webpack_public_path__ + "static/media/choose-mobywatel-icon.ddb18b84ef75fd9e70b05547749622af.svg";
export { ForwardRef as ReactComponent };